export default __webpack_public_path__ + "static/media/_logo-finanzas.0ed886c1.png";